import * as Yup from 'yup';

export const Schema = Yup.object().shape({
  name: Yup.string().required('This field is required.'),
  priority: Yup.number().required('This field is required.'),
  status: Yup.string().required('This field is required.'),
});
